import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import TicketSaleMenu from './ticket-sale-menu';
import TicketSaleCreate from './ticket-sale-create';
import TicketSaleIndex from './ticket-sale-index';
import TicketSaleDetail from './ticket-sale-detail';
import TicketSaleReport from './ticket-sale-report';

import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    }
}));

const TicketSale = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) return <Loader />;
    if (!state.permissions?.read_attr) return <NotFound />;

    return (
        <div className={classes.root}>
            <ViewTitle sedeFlag title='Ticket sale' />

            <Switch>
                <Route exact path={path}><TicketSaleMenu permissions={state.permissions} /></Route>
                <Route exact path={`${path}/report`}><TicketSaleReport permissions={state.permissions} /></Route>
                <Route exact path={`${path}/create`}><TicketSaleCreate permissions={state.permissions} /></Route>
                <Route exact path={`${path}/index`}><TicketSaleIndex permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/:id`}><TicketSaleDetail permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default TicketSale;